<div class="v-middle-children">
  <button
    *ngIf="status !== '0'"
    [ngbTooltip]="moreStatus"
    tooltipClass="skill-standards-segment-status-popover"
    [container]="'body'"
    [placement]="'bottom'"
    data-dgat="skill-standards-segment-status-indicator-f95"
  >
    <div class="color-ebony-a61">
      <df-icon icon="exclamation-circle" class="color-warning"></df-icon>
    </div>
  </button>
</div>

<ng-template #moreStatus>
  <table class="color-ebony">
    <tr>
      <td>
        <df-icon
          icon="exclamation-circle"
          class="guts-m-l-quart color-warning"
        ></df-icon>
      </td>
      <td class="guts-p-h-1">{{ statusDisplay(status) }}</td>
      <td *ngIf="status === '2'">
        <span class="badge badge-pill badge-attention">{{ count }}</span>
      </td>
    </tr>
  </table>
</ng-template>
